import {setSlideTransition, SLIDE_PROPS} from './slide';

export default function slideUp(el, { speed = 300 } = {}, offsetHeight = el.offsetHeight) {
  setSlideTransition(el, speed);

  el.style.maxHeight = `${offsetHeight || 0}px`;
  el.style.overflow = 'hidden';

  setTimeout(function() {
    SLIDE_PROPS.forEach(prop => el.style[prop] = 0);
  }, 0);

  setTimeout(function() {
    el.style.display = 'none';
    SLIDE_PROPS.concat('transition', 'overflow').forEach(prop => el.style[prop] = '');
  }, speed);
}
